var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAddMember(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.2513 8.2233C8.78158 8.2233 10.0221 6.98276 10.0221 5.45247C10.0221 3.92218 8.78158 2.68164 7.2513 2.68164C5.72101 2.68164 4.48047 3.92218 4.48047 5.45247C4.48047 6.98276 5.72101 8.2233 7.2513 8.2233Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7923 12.2232C12.7923 13.1673 10.3083 14.3195 7.25063 14.3195C4.19296 14.3195 1.70898 13.066 1.70898 12.2232C1.70898 11.0603 4.19296 9.33203 7.25063 9.33203C10.3083 9.33203 12.7923 11.0603 12.7923 12.2232Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2384 5.07227V6.89977H16.0007V7.97669H14.2384V9.73893H13.1615V7.97669H11.334V6.89977H13.1615V5.07227H14.2384Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAddMember);
export default __webpack_public_path__ + "static/media/ic_add_member.9f24c375ed896749e06057df1d8e674b.svg";
export { ForwardRef as ReactComponent };